import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LanguageService } from '../../shared/services/language.service';
import Decimal from 'decimal.js';
import { DocumentItem } from '../../shared/sdk';

@Component({
  selector: 'app-document-totals-table',
  templateUrl: './document-totals-table.component.html',
  styleUrls: ['./document-totals-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentTotalsTableComponent implements OnInit, OnDestroy {
  @Input() currency: string;
  @Input() equalizationCtrl: FormControl;
  @Input() equalizationValue: number;
  @Input() hasTax: boolean;
  @Input() inForeignCurrency: boolean;
  @Input() items: DocumentItem[];
  @Input() locale: string;
  @Input() taxes: any[];
  @Input() total: number;
  @Input() totalDiscount: number;
  @Input() totalWithTax: number;
  private onDestroy$ = new Subject<void>();

  constructor(private languageService: LanguageService) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    if (this.equalizationCtrl) {
      this.equalizationCtrl.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          const min = -0.1;
          const max = min * -1;
          let eqVal = value;

          if (!this.languageService.isC(eqVal)) {
            return;
          }

          eqVal = this.languageService.u(eqVal || 0);
          const eq = new Decimal(eqVal);

          if (!eq.eq(0)) {
            // Out of bounds
            if (eq.gt(max) || eq.lt(min)) {
              const times = eq.lt(min);
              const closest = times ? min : max;
              this.equalizationCtrl.setValue(this.languageService.f(closest));
            } else {
              const rounded = eq.toDP(2, Decimal.ROUND_FLOOR);

              // More than 2 dp
              if (!eq.eq(rounded)) {
                this.equalizationCtrl.setValue(this.languageService.f(rounded));
              }
            }
          }
        });
    }
  }

  get showEqualization(): boolean {
    let val = 0;

    if (this.equalizationCtrl && this.equalizationCtrl.value) {
      val = this.equalizationCtrl.value;
    } else if (this.equalizationValue) {
      val = this.equalizationValue;
    }

    const show = val !== 0 && val !== null;
    return show;
  }
}
